import type { Claim, ClaimItem } from '../../../../types/LegalCase';

// Título vindo da cobrança (settlement): a cobrança é a dona do dado. Mesmo critério do backend
// (ADR 005, decisão 7): tipo TITLE_DEBT ou obligationId (o title_debt_id) preenchido. Editar,
// excluir ou lançar pagamento à mão nele induz a erro — saldo e situação chegam por evento.
export const isFromCollection = (item: ClaimItem): boolean =>
    item.obligationType === 'TITLE_DEBT' || !!item.obligationId;

// Os títulos que a seção Cobrança consegue mostrar (Task 16 / AF-3694): os do tipo TITLE_DEBT com o
// `title_debt_id`, que é a chave do dossiê na cobrança. A garantia entra também: ela tem dossiê
// próprio, e o jurídico precisa ver o que a cobrança fez com ela mesmo fora do total da pretensão.
export const collectionTitles = (claim: Claim | null | undefined): ClaimItem[] =>
    (claim?.items || []).filter((item) => item.obligationType === 'TITLE_DEBT' && !!item.obligationId);
